import React, { useState } from "react";
import { useApp } from "../../context/AppContext";
import { toast } from "../ui/sonner";
import { FileBarChart2, Mail } from "lucide-react";

/* 运营战报：当月 PDF（分公司榜 / 趋势 / 排行 / 收款 / 需收款）；VP 可一键邮件 CEO + 分公司销售经理 */
export default function CockpitReportCard({ region }) {
  const { api, lang, user } = useApp();
  const zh = lang === "zh";
  const [emailing, setEmailing] = useState(false);
  const canEmail = ["admin", "ceo", "sales_vp"].includes(user.role);
  const month = new Date().toISOString().slice(0, 7);

  const download = async () => {
    try {
      const res = await api.get("/reports/ops-cockpit-pdf", { params: { lang }, responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `ops_report_${month}${region ? `_${region}` : ""}.pdf`; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success(zh ? "运营战报 PDF 已生成" : "Report downloaded");
    } catch (e) { toast.error(e?.response?.data?.detail || (zh ? "战报生成失败" : "Report failed")); }
  };

  const email = async () => {
    if (!window.confirm(zh ? "将当月运营战报（全公司版）邮件发送给 CEO 与三位分公司销售经理，并抄送你本人。确认发送？" : "Email this month's report to the CEO and branch sales managers (cc you)?")) return;
    setEmailing(true);
    try {
      const { data } = await api.post("/reports/ops-cockpit-email", { lang });
      const ok = data.results.filter((r) => r.ok).length;
      toast.success(zh ? `已发送 ${ok}/${data.results.length} 封：${data.recipients.map((r) => r.name).join("、")}` : `Sent ${ok}/${data.results.length}`);
    } catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setEmailing(false);
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 flex flex-wrap items-center justify-between gap-3" data-testid="cockpit-report">
      <div>
        <h3 className="font-semibold text-slate-900 flex items-center gap-2"><FileBarChart2 className="h-4 w-4 text-red-600" />{zh ? `运营战报 · ${month}` : `Operations Report · ${month}`}</h3>
        <p className="text-slate-500 text-xs mt-1">
          {zh ? "一份 PDF：分公司业绩榜 · 近 6 个月趋势 · 销售排行 & 目标达成 · 各小组收款/应收 · 各收款节点 · 本月需收款项目" : "Branch scoreboard · 6-month trend · leaderboard & targets · collections · due this month"}
          {region && <span className="ml-1 text-amber-700">{zh ? "（本区域版）" : " (your branch)"}</span>}
        </p>
      </div>
      <div className="flex items-center gap-2">
        <button data-testid="cockpit-report-download" onClick={download} className="inline-flex items-center gap-1.5 text-sm text-slate-800 border border-slate-300 hover:border-brand-400 hover:text-brand-500 rounded-lg px-3 py-2 transition-colors">
          <FileBarChart2 className="h-4 w-4" />{zh ? "导出当月战报 PDF" : "Export PDF"}
        </button>
        {canEmail && (
          <button data-testid="cockpit-report-email" onClick={email} disabled={emailing} className="inline-flex items-center gap-1.5 text-sm text-white bg-brand-500 hover:bg-brand-600 disabled:opacity-50 rounded-lg px-3 py-2 transition-colors">
            <Mail className="h-4 w-4" />{emailing ? (zh ? "发送中…" : "Sending…") : (zh ? "发 CEO + 分公司经理" : "Email CEO + managers")}
          </button>
        )}
      </div>
    </div>
  );
}
